// extracted by mini-css-extract-plugin
export default {"menuBlock":"OF-z","title":"PF-z","nav":"QF-z","flexCell":"RF-z","facetLink":"SF-z"};